import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useSettings } from "@/contexts/SettingsContext";

// The sitewide "Start a Project" CTA — text/link editable once from Admin -> Header,
// reflected everywhere this button appears (navbar, blog posts, service pages, etc).
export const PrimaryCtaButton = ({ className = "btn-gradient gap-2 inline-flex", testId = "primary-cta-button" }) => {
  const settings = useSettings();
  const ctaText = settings.cta_text || "Start a Project";
  const ctaLink = settings.cta_link || "/contact";

  return (
    <Link to={ctaLink} data-testid={testId} className={className}>
      {ctaText} <ArrowUpRight size={18} weight="bold" />
    </Link>
  );
};
